function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.958 12.9C20.4426 12.8995 20.012 12.5075 19.9633 11.9944C19.9146 11.4814 20.2639 11.0153 20.77 10.918C22.4343 10.5973 23.7158 9.26237 23.9684 7.58632C24.221 5.91027 23.3898 4.257 21.8939 3.46002C20.3979 2.66305 18.5621 2.89543 17.312 4.04C17.0476 4.28044 16.675 4.36157 16.3346 4.25284C15.9942 4.1441 15.7376 3.86201 15.6616 3.51284C15.5856 3.16366 15.7016 2.80044 15.966 2.56C17.8431 0.847906 20.5951 0.503695 22.8361 1.7007C25.0771 2.89771 26.3212 5.37641 25.942 7.88861C25.5628 10.4008 23.6424 12.4018 21.148 12.884C21.0852 12.8951 21.0216 12.9005 20.958 12.9Z",
  fill: "#32D882"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M30 25H27C26.4477 25 26 24.5523 26 24C26 23.4477 26.4477 23 27 23H30V20C30 19.4477 30.4477 19 31 19C31.5523 19 32 19.4477 32 20V23C32 24.1046 31.1046 25 30 25Z",
  fill: "#32D882"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M31 21C30.7651 20.9998 30.5378 20.917 30.358 20.766C27.3164 18.2059 23.4307 16.8698 19.458 17.018C18.9063 17.0394 18.4416 16.6097 18.42 16.058C18.3986 15.5063 18.8283 15.0417 19.38 15.02C23.8489 14.85 28.2208 16.3517 31.642 19.232C31.9655 19.5018 32.0852 19.9454 31.9415 20.3413C31.7977 20.7373 31.4212 21.0006 31 21Z",
  fill: "#32D882"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6 11C6 14.3137 8.68629 17 12 17C13.5913 17 15.1174 16.3679 16.2426 15.2426C17.3679 14.1174 18 12.5913 18 11C18 7.68629 15.3137 5 12 5C8.68629 5 6 7.68629 6 11ZM8 11C8 8.79086 9.79086 7 12 7C13.0609 7 14.0783 7.42143 14.8284 8.17157C15.5786 8.92172 16 9.93913 16 11C16 13.2091 14.2091 15 12 15C9.79086 15 8 13.2091 8 11Z",
  fill: "#32D882"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M22 29H2C0.89543 29 0 28.1046 0 27V24C0 23.4477 0.447715 23 1 23C1.55228 23 2 23.4477 2 24V27H22V24C22 23.4477 22.4477 23 23 23C23.5523 23 24 23.4477 24 24V27C24 28.1046 23.1046 29 22 29Z",
  fill: "#32D882"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M23 25C22.7652 24.9998 22.5379 24.917 22.358 24.766C16.3696 19.7355 7.63241 19.7355 1.64401 24.766C1.36999 24.9957 0.994227 25.0618 0.658271 24.9394C0.322315 24.8169 0.0772047 24.5245 0.0152711 24.1724C-0.0466624 23.8202 0.0839899 23.4617 0.358013 23.232C7.09007 17.5771 16.912 17.5771 23.644 23.232C23.9678 23.502 24.0875 23.9461 23.9432 24.3423C23.7989 24.7384 23.4216 25.0015 23 25Z",
  fill: "#32D882"
});

var SvgVenueManagment11 = function SvgVenueManagment11(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 29,
    viewBox: "0 0 33 29",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVenueManagment11, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/venue-managment11.2d373a64.svg";
export { ForwardRef as ReactComponent };